var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_gif"},[_c('div',{staticClass:"image_loader"},[_c('img',{attrs:{"src":require("../../assets/media/images/Icons/loader.gif"),"alt":"","width":"250","height":"250"}})]),_c('span')])
}]

export { render, staticRenderFns }